import moment from "moment";
import { ApiSubtask } from "src/api/types";
import Button from "src/components/Button";
import Card from "src/components/Card";
import withTranslation, {
	Translation,
} from "src/components/hoc/withTranslation";
import TaskMatchProgress from "src/components/tasks/TaskMatchProgress";

interface SubtaskCardProps extends Translation {
	task: ApiSubtask;
}

const SubtaskCard = ({ t, task }: SubtaskCardProps) => {
	const start = moment(task.start_date).format("DD-MM-YYYY");
	// const end = moment(task.end_date).format("DD-MM-YYYY");
	// let date = `${start} - ${end}`;
	const time: any = {
		start: moment(task.start_date).format("HH:mm"),
		end: moment(task.end_date).format("HH:mm"),
	};

	// if (start === end) {
	// 	date = start;
	// }

	return (
		<Card className="min-w-[320px]">
			<div className="flex flex-col gap-6">
				<div className="flex gap-4">
					<SubtaskIcon {...{ task }} />
					<div className="flex flex-col">
						<strong>{task.title}</strong>
						<p>
							{start}

							{time.start && (
								<span className="ml-2">
									{time.start} - {time.end}
								</span>
							)}
						</p>
					</div>
				</div>
				<TaskMatchProgress
					students={task.amount_of_students}
					matched={task.matches.count}
				/>
				<div className="flex flex-wrap gap-4">
					<Button
						className="flex-1 md:flex-auto"
						to={`/tasks/${task.hid}/show`}
						type="dark"
					>
						<i className="far fa-users mr-4"></i>
						{t("actions.registrations")}
					</Button>
					<Button
						className="flex-1 md:flex-auto"
						to={`/tasks/${task.hid}/edit`}
						type="gray"
					>
						<i className="far fa-pencil mr-4"></i>
						{t("actions.edit")}
					</Button>
				</div>
			</div>
		</Card>
	);
};

SubtaskCard.locale = {
	nl: {
		actions: {
			registrations: "Aanmeldingen",
			edit: "Aanpassen",
		},
	},
	en: {
		actions: {
			registrations: "Registrations",
			edit: "Edit",
		},
	},
};

const SubtaskIcon = ({ task }: { task: ApiSubtask }) => {
	const status =
		task.matches?.count >= task.amount_of_students ? "filled" : "pending";
	const classes = {
		pending: "bg-gray",
		filled: "bg-green-500 text-green",
	};
	const icons = {
		pending: "far fa-clock",
		filled: "far fa-check",
	};

	return (
		<div
			className={`w-12 h-12 flex justify-center items-center rounded-md ${classes[status]}`}
		>
			<i className={icons[status]}></i>
		</div>
	);
};

export default withTranslation(SubtaskCard);
